// extracted by mini-css-extract-plugin
module.exports = {"Timer":"Timer_Timer__1QdpB","Time":"Timer_Time__tYguz","TimerPaused":"Timer_TimerPaused__WS1FR"};